<div class="page-title-bar mb-4 flex-sm-row d-flex justify-content-between align-items-start pt-2" style="padding-left: 18px;
    padding-right: 18px;    align-items: center !important;">
    <div class="title d-flex align-items-center new_tiglle">
      <div class="new_itwm">
      <button *ngIf="showBackButton" mat-icon-button [routerLink]="['../']"   class="me-3">
        <mat-icon class="material-icons-round">arrow_back</mat-icon>
      </button>
      <button *ngIf="showBackToDashboard" mat-icon-button (click)="goToBack()"   class="me-3">
        <mat-icon class="material-icons-round">arrow_back</mat-icon>
      </button>
      <button *ngIf="backWithParams" mat-icon-button (click)="goToBackWithParams()"   class="me-3">
        <mat-icon class="material-icons-round">arrow_back</mat-icon>
      </button>
      <button *ngIf="back" mat-icon-button (click)="backButton()"   class="me-3">
        <mat-icon class="material-icons-round">arrow_back</mat-icon>
      </button>
    </div>
      <div class="ms_items">
        <h1 *ngIf="pageTitle">{{pageTitle |titlecase}}</h1>
        <h2 class="m-0" *ngIf="pageSubTitle">{{pageSubTitle}}</h2>
      </div>

    </div>
    <ng-container *ngTemplateOutlet="headerCustomTemplate"></ng-container>
    
    <button *ngIf="showButton" mat-button (click)="onTitlebarButtonClick()">{{showButton}}</button>
  </div>
  